<template>
  <div class="quick_match">
    <div class="secoundBton" style="text-align: right;" v-loading="quick_match_loading">
      <div style="margin: 16px 0">
        <el-button type="primary" round @click="onclickAddQuickTask" style="margin-right: 16px;background-color: #FFC215;border: #FFC215">+NEW</el-button>
      </div>
      <!--    <el-scrollbar style="height: calc(100vh - 290px)"  >-->
      <div class="innerTable" v-if="quick_match_table_data.length!=0">
        <el-table
          :data="quick_match_table_data"
          style="width: 100%;font-weight: normal;">
          <el-table-column
            header-align="center"
            align="center"
            prop="invoice#"
            label="Invoice#"
            min-width="20%"
          >
            <template slot-scope="scope">
              <div class="innerBtom" v-if="scope.row.is_relation == 1">{{scope.row.invoice_number}}-{{scope.row.is_pickup == 0?'D':'P'}}/{{suffix}}</div>
              <div class="innerBtom" v-else>{{scope.row['invoice#']}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="address_desc"
            label="content"
            min-width="30%"
          >
            <template slot-scope="scope">
              <div class="innerBtom"> <span v-if="scope.row.code!= ''">{{scope.row.code}}</span> {{scope.row.recipient_name}}</div>
              <div class="innerBtom">{{scope.row.address_desc}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Driver"
            min-width="30%"
          >
            <template slot-scope="scope">
              <div>
                <span style="cursor: pointer" v-if="scope.row.show_select === false" @click="chagneShowSelect(scope.$index,scope.row)">{{scope.row.worker_name}}</span>
                <span v-if="scope.row.show_select === true">
                <el-select v-model="scope.row.worker"
                           placeholder="All"
                           ref="quick_select"
                           @change="changeDriverHandles($event, scope)"
                           @blur="hideDriverSelectHandle(scope)"
                           style="width: 300px">
                <el-option
                  v-for="item in drver_select"
                  :key="item.worker_id"
                  :label="item.name"
                  :value="item.worker_id"
                >
                </el-option>
                <div style="clear: both">
                </div>
              </el-select>
              </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            prop="actions"
            width="120"
            label="Actions">
            <template slot-scope="scope">
              <div class="action">
              <span  @click="onQuickHandleDelete(scope.$index, scope.row)">
              <img src="../assets/quickMatch/clear@2x.png" alt="">
              </span>
                <span  @click="quickHandleView(scope.$index, scope.row)">
              <img src="../assets/quickMatch/view@2x.png" alt="">
              </span>
              </div>
            </template>
          </el-table-column>
        </el-table>

      </div>
      <!--      </el-scrollbar>-->
      <div v-else class="empty">
        <div style="text-align: center">
          <img src="../assets/image/list_blank.png" alt="">
          <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
        </div>
      </div>
      <div class="btom">
        <div class="innerLeft">{{send_message.page}} - <span>{{quick_match_table_data.length}}</span> of <span>{{total}}</span> items</div>
        <div>
          <el-pagination
            :page-size="10"
            layout="prev, pager, next, jumper"
            @current-change="handleSizeChange"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--  详情dialog-->
    <el-dialog
      :close-on-click-modal="false"
      custom-class="right"
      title="Task Details"
      :visible.sync="detialDialog"
      width="30%">
      <task-detial :info="info" ref="quickTaskDetialRef"></task-detial>
    </el-dialog>
    <!--  编辑弹框 或者复制-->
      <el-dialog
        :close-on-click-modal="false"
        custom-class="noRadio"
        fullscreen
        :visible.sync="quickTaskDiog"
        @close="clearDialogDialog"
      >
        <quick_match_add_new ref="quick_match_add" @closeDialog = 'clearDialogDialog'></quick_match_add_new>
<!--        <add-new-tasks :title="title" :quick_add="true" ref="createTasks"  @closeDialog="closeDialog"></add-new-tasks>-->
      </el-dialog>
  </div>
</template>

<script>
import {
  cancelAssignedDriverHandle, deleteTaskHandle,
  quickAssignedDriverHandle,
  quickMatchHandle,
  quickMatchList
} from "@/api/quickMatch";
import {getDriverList, scanTask} from "@/api/tasks";
import EventBus from "@/ws/eventBus";
import taskDetial from "@/components/taskDetial";
import quick_match_add_new from "@/components/quick_match_add_new";
import {debounce} from '@/utils'

export default {
  name: "quickMatch",
  props:{
    send_message:{
      type:Object,
      default: () => {}
    }
  },
  components:{
    taskDetial,quick_match_add_new
  },
  data(){
    return{
      title:'Create a New Task',
      quickTaskDiog:false,
      detialDialog:false,
      info:'',
      quick_match_table_data:[{
        invoice:'11',
        contact:'11',
        driver:'11',
      }],
      quick_match_loading:false,
      total:'',
      drver_select:'',
      assigned_driver:false,//是否分配给司机
      currentScanTask:'',//当前扫码的任务

      onQuickHandleDelete:null,
      suffix:'',
    }
  },
  watch:{
    send_message:{
      handler(newValue, oldValue) {
        this.getQuickMatchList()
      },
      deep: true,
    }
  },
  created() {
    // console.log(localStorage.getItem('userInfoDetail'))
    this.suffix = JSON.parse(localStorage.getItem('userInfoDetail')).suffix
    // console.log(this.suffix)
    this.getQuickMatchList()
    getDriverList({token:localStorage.getItem('token')}).then(res=>{
      this.drver_select = res.data
    })
    EventBus.$on('updateQuickTaskList',(a)=>{
      // console.log(a,'ddd')
      this.quick_match_table_data.unshift(a)
    })
    let currentScanTask = sessionStorage.getItem('currentScanTask')
    // console.log(currentScanTask,'currentScanTask')
    //这里需要判断一下 当前列表种是否有 未分配的任务，如果没有的话 且currentScanTask 有值 就要把他清空
    // console.log(this.quick_match_table_data,'quick_match_table_dataquick_match_table_dataquick_match_table_data')

    if (currentScanTask){
      this.currentScanTask = currentScanTask

    }else {
      this.currentScanTask = ''
    }
    //fangdou
    this.onQuickHandleDelete = debounce((d, name) => {
      // console.log('asdfasdf,',d,name)
      if(name.worker == '' || name.worker == null || name.worker == undefined){
        this.quickHandleDelete(d, name)
      }else{
        let result =  this.checkData()
        if (result  == false) {
          this.quickHandleDelete(d, name)
        }
      }
		}, 500)


  },
  methods:{
    async  onclickAddQuickTask (){
      let result =  this.checkData()
      if(result == false){
        this.quickTaskDiog = true
      }else{}
    },
    checkData(){
      let flag = false
      this.quick_match_table_data.forEach(v => {
        if(v.worker_name == 'Unassigned'){
          console.log(v.worker,v,'sss')
          this.$message({
           type:"error",
           message:'Please scan a correct driver code.'
         })
         flag = true

         setTimeout(()=>{
          this.$refs.quick_select.focus()
          },1000)

          return  flag
        }
      });
      return flag;
    },

    //手动修改分配司机
    changeDriverHandles(e, scope){
      const driverItem = this.drver_select.find(item => item.worker_id === e)
      if (driverItem) {
        scope.row.worker_name = driverItem.name
      }
      scope.row.show_select = false
      quickAssignedDriverHandle({
        worker_code:driverItem.code,
        task_id:scope.row.task_id,
      }).then(res=>{
        if (res.code == 200){
          this.currentScanTask = ''
          localStorage.setItem('currentScanTask','')
          this.$message({
            type:'success',
            message:'Assigned successfully'
          })
          //刷新列表
          this.getQuickMatchList()

        }
      })
    },
    hideDriverSelectHandle(scope){
      setTimeout(()=>{
       scope.row.show_select = false
      },300)
    },
    closeDialog(){
      this.quickTaskDiog = false
      this.$forceUpdate()
      // this.getQuickMatchList()
    },
    clearDialogDialog(){
      this.$refs.quick_match_add.active = 0
      this.$refs.quick_match_add.form_one["invoice#"] = ''
      this.$refs.quick_match_add.address_form.code = ''
      this.$refs.quick_match_add.validateclearForm()
      this.quickTaskDiog = false
      this.getQuickMatchList()
    },
    chagneShowSelect(index,row){
      //[X] 不做限制由接口返回提示 2023年10月17日
      //检查当前任务是否已经分配了司机
      // if(row.worker != '' || row.worker != null || row.worker != undefined){
      //   this.$message({
      //      type:"error",
      //      message:'The driver has started the task.'
      //    })
      //    return
      // }
      // 查询数组中是否有 下拉框存在得 如果有得话 将下拉框隐藏
      let check_select = this.quick_match_table_data.findIndex(v=>v.show_select == true)
      if  (check_select >0){
        this.quick_match_table_data[check_select].show_select = false
      }
      this.$set(this.quick_match_table_data, index, Object.assign({}, this.quick_match_table_data[check_select], { show_select: true }));
      row.show_select = true
      this.currentScanTask = row.task_id
      this.assigned_driver = true
      this.$set(this.quick_match_table_data,index,row)
      this.$set(this.quick_match_table_data, index, Object.assign({}, this.quick_match_table_data[index], { show_select: true }));
      setTimeout(()=>{
        this.$refs.quick_select.focus()
      })
    },
   getQuickMatchList(){
     this.quick_match_loading = true
     quickMatchList(this.send_message).then(res=>{
       this.quick_match_loading = false
       if (res.code == 200){
         this.quick_match_table_data = res.data.data
         let empty_work = this.quick_match_table_data.findIndex(v=>v.worker_name == 'Unassigned')
         if (empty_work == -1){
           this.currentScanTask = ''
           console.log('没有任务未分配，但是有任务id存储')
           sessionStorage.setItem('currentScanTask','')
         }
         this.quick_match_table_data.forEach(v=>{
           v.show_select = false
           v.drver_select = this.drver_select
           if(v.worker == '' || v.worker == null || v.worker == undefined){
             this.currentScanTask = v.task_id
          //  if(v.worker == ''){
              v.show_select = true
              setTimeout(()=>{
                // this.$refs.quick_select.focus()
              },1000)
           }
        })

        // this.total =res.data.data.length
        this.total =res.data.count

       } else {
         this.$message({
           type:"error",
           message:res.mes
         })
       }
     })
   },
    getQuickMatch(barCode){
      console.log(this.assigned_driver,'分配给司机')
     if (this.currentScanTask == ''){
       barCode =barCode.replace(/(\r\n|\r|\n)+/g, '')
       console.log(barCode)
       quickMatchHandle({
         data: barCode
       }).then((res) => {
         if (res.code === 200) {
           // EventBus.$emit('newTaskCome')
           this.$message({
             message: res.msg,
             type: 'success',
           });
           res.data.worker_name = 'Unassigned'
           this.quick_match_table_data.unshift(res.data)
            setTimeout(()=>{
             let row_index = this.quick_match_table_data.findIndex(v=>v.task_id == res.data.task_id)
             let row_task = this.quick_match_table_data[row_index]
             row_task.show_select = true
             this.$set(this.quick_match_table_data,row_index,row_task)
             this.$set(this.quick_match_table_data, row_index, Object.assign({}, this.quick_match_table_data[row_index], { show_select: true }));
             this.currentScanTask = res.data.task_id
              sessionStorage.setItem('currentScanTask',this.currentScanTask)
           },100)
         } else {
           this.$message({
             message: res.msg,
             type: 'error',
           });
         }
       }).catch((error) => {
         this.submitLoading = false;
         this.$message({
           message: error.data.msg,
           type: 'error',
         });
       });
     }else {
       quickAssignedDriverHandle({
         worker_code:barCode,
         task_id:this.currentScanTask
       }).then(res=>{
         if(res.code == 200){
           console.log(this.quick_match_table_data)
          let is_relation= this.quick_match_table_data.findIndex(b=>b.is_relation == 1)
           let row_index = this.quick_match_table_data.findIndex(v=>v.task_id == this.currentScanTask)
           if (is_relation>-1 && this.quick_match_table_data[is_relation].worker_name == 'Unassigned'){
             this.getQuickMatchList()
           }else {
             let row_task = this.quick_match_table_data[row_index]
             row_task.worker_name = res.data.worker_name
             this.$set(this.quick_match_table_data,row_index,row_task)
             this.$set(this.quick_match_table_data, row_index, Object.assign({}, this.quick_match_table_data[row_index], { show_select: false }));
           }
           this.currentScanTask = ''
           sessionStorage.setItem('currentScanTask',this.currentScanTask)
           this.$message({
             type:'success',
             message:res.msg
           })
         }else {
           this.$message({
             type:'error',
             message:res.msg
           })
         }
       })
     }
    },
    quickHandleDelete(index,row){
     this.quick_match_table_data.forEach(v=>{
       if (v.task_id == row.task_id){
         console.log(v.worker,'ssss')
         if (v.worker_name == 'Unassigned'){
           //说明已经是未指派的状态 点击的话删除任务
           deleteTaskHandle({
             task_id:v.task_id
           }).then(res=>{
             if (res.code == 200){
               this.$message({
                 type:'success',
                 message:res.msg
               })
               this.getQuickMatchList()
               this.currentScanTask = ''
               sessionStorage.setItem('currentScanTask',this.currentScanTask)

              //刷新列表
              this.getQuickMatchList()

            }else {
               this.$message({
                 type:'error',
                 message:res.msg
               })
             }
           }).catch(err=>{
             this.$message({
               type:'error',
               message:err.msg
             })
           })
         } else {
           //说明已经指派了 点击取消指派
           cancelAssignedDriverHandle({
             task_id:v.task_id
           }).then(res=>{
             if (res.code == 200){
               v.worker = ''
               v.worker_name = "Unassigned"
               v.show_select = true

               this.currentScanTask = v.task_id
               this.currentScanTask = v.task_id
               sessionStorage.setItem('currentScanTask',this.currentScanTask)
               this.$message({
                 type:'success',
                 message:res.msg
               })

              // setTimeout(()=>{
              //   this.$refs.quick_select.focus()
              // },3000)

              //刷新列表
            this.getQuickMatchList()

             }else {
               this.$message({
                 type:'error',
                 message:res.msg
               })
             }
           }).catch(err=>{
             this.$message({
               type:'error',
               message:err.msg
             })
           })
         }
       }
     })
    },
    quickHandleView(index,row){
          this.info = row
          this.detialDialog = true
          setTimeout(()=>{
            this.$refs.quickTaskDetialRef.getData()
          },100)
    },
    handleSizeChange(val){
      this.send_message.page = val
      this.getQuickMatchList()
    },
  }
}
</script>

<style scoped lang="less">
.quick_match{
  .innerTable{
    img{
      width: 16px;
      margin: 0 8px;
      cursor: pointer;
    }
  }
  .btom{
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    .innerLeft{
      font-size: 16px;
      font-family: SFPro-Regular, SFPro;
      font-weight: 400;
      color: #1F2D42;
      line-height: 20px;
    }
  }
}
</style>
